import { render, staticRenderFns } from "./SpamFiltersView.vue?vue&type=template&id=59aae0d4&scoped=true&"
import script from "./SpamFiltersView.vue?vue&type=script&lang=js&"
export * from "./SpamFiltersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aae0d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59aae0d4')) {
      api.createRecord('59aae0d4', component.options)
    } else {
      api.reload('59aae0d4', component.options)
    }
    module.hot.accept("./SpamFiltersView.vue?vue&type=template&id=59aae0d4&scoped=true&", function () {
      api.rerender('59aae0d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/email/SpamFiltersView.vue"
export default component.exports